'use client';

import { __makeTemplateObject, __rest } from '../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import { EAlertType, colors as colors$1 } from '../Utils/constants.js';
import { getAlertColorRange, colors } from '../Colors/index.js';

var Input = styled.input.attrs(function (props) {
    return {
        colorRangeBaseOnType: getAlertColorRange(props.alertType)
    };
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    -webkit-appearance: none;\n    cursor: pointer;\n    position: relative;\n    display: block;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 1px solid\n        ", ";\n    background: unset;\n    opacity: ", ";\n    &:focus {\n        outline: none;\n    }\n\n    ", "\n\n    ", "\n\n    &:checked {\n        border: 5px solid\n            ", ";\n    }\n"], ["\n    -webkit-appearance: none;\n    cursor: pointer;\n    position: relative;\n    display: block;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 1px solid\n        ", ";\n    background: unset;\n    opacity: ", ";\n    &:focus {\n        outline: none;\n    }\n\n    ", "\n\n    ", "\n\n    &:checked {\n        border: 5px solid\n            ", ";\n    }\n"])), function (props) {
    if (props.alertType === EAlertType.danger || props.checked) {
        return props.colorRangeBaseOnType[40];
    }
    return colors.grey[40];
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.4 : 1);
}, function (_a) {
    var isDropdownRadio = _a.isDropdownRadio, props = __rest(_a, ["isDropdownRadio"]);
    return !isDropdownRadio && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            &:hover {\n                border-color: ", ";\n            }\n        "], ["\n            &:hover {\n                border-color: ", ";\n            }\n        "])), props.alertType === EAlertType.danger || props.checked
        ? props.colorRangeBaseOnType[40]
        : props.disabled
            ? colors.grey[40]
            : props.colorRangeBaseOnType[70]);
}, function (props) {
    return props.isHover
        ? "\n        border-color: ".concat(props.colorRangeBaseOnType[70], ";\n    ")
        : '';
}, function (props) {
    if (props.alertType === EAlertType.danger || props.checked) {
        return props.colorRangeBaseOnType[40];
    }
    return props.colorRangeBaseOnType[40];
});
var Container = styled.label(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: ", ";\n    align-items: ", ";\n    justify-content: ", ";\n    ", ";\n    margin: 0;\n    column-gap: 16px;\n    height: ", ";\n    font-size: 14px;\n    ", ";\n    ", "\n    cursor: ", ";\n    ", ";\n    ", "\n    > * {\n        pointer-events: ", ";\n    }\n    input[type='radio'] {\n        margin: 0;\n        &:focus {\n            outline: none;\n        }\n    }\n\n    ", "\n"], ["\n    display: flex;\n    flex-direction: ", ";\n    align-items: ", ";\n    justify-content: ", ";\n    ", ";\n    margin: 0;\n    column-gap: 16px;\n    height: ", ";\n    font-size: 14px;\n    ", ";\n    ", "\n    cursor: ", ";\n    ", ";\n    ", "\n    > * {\n        pointer-events: ", ";\n    }\n    input[type='radio'] {\n        margin: 0;\n        &:focus {\n            outline: none;\n        }\n    }\n\n    ", "\n"])), function (_a) {
    var isLeftRadio = _a.isLeftRadio;
    return (isLeftRadio ? 'row' : 'row-reverse');
}, function (_a) {
    var customLabel = _a.customLabel;
    return (customLabel ? 'start' : 'center');
}, function (_a) {
    var customLabel = _a.customLabel;
    return (customLabel ? 'space-between' : 'start');
}, function (_a) {
    var noLabel = _a.noLabel;
    return !noLabel && 'padding: 0 8px';
}, function (_a) {
    var height = _a.height, customLabel = _a.customLabel;
    if (!customLabel) {
        return height < 24 ? '24px' : "".concat(height, "px");
    }
    return 'auto';
}, function (_a) {
    var width = _a.width;
    return width && "width: ".concat(width);
}, function (_a) {
    var isDropdownRadio = _a.isDropdownRadio, disabled = _a.disabled, notLabel = _a.notLabel;
    return isDropdownRadio && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            &:hover {\n                background-color: ", ";\n                ", ";\n            }\n        "], ["\n            &:hover {\n                background-color: ", ";\n                ", ";\n            }\n        "])), disabled ? "tranparent" : "".concat(colors.primary[99]), notLabel && 'background-color: unset;');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var notLabel = _a.notLabel;
    return notLabel && 'background-color: unset;';
}, function (_a) {
    var isHover = _a.isHover;
    return (isHover ? "background-color: ".concat(colors$1.bgHover, ";") : '');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'all');
}, function (_a) {
    var checked = _a.checked, isDropdownRadio = _a.isDropdownRadio; _a.disabled;
    return checked &&
        isDropdownRadio && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            background: ", " !important;\n            p {\n                color: ", " !important;\n            }\n        "], ["\n            background: ", " !important;\n            p {\n                color: ", " !important;\n            }\n        "])), colors.primary[95], colors.primary[40]);
});
var Label = styled.p(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex: 1;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    word-break: break-word;\n    color: ", ";\n    opacity: ", ";\n"], ["\n    flex: 1;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    -webkit-line-clamp: 1;\n    word-break: break-word;\n    color: ", ";\n    opacity: ", ";\n"])), colors$1.textColor, function (_a) {
    var isDisable = _a.isDisable;
    return (isDisable ? 0.4 : 1);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

export { Container, Input, Label };
//# sourceMappingURL=Radio.css.js.map
